import { Platform } from 'react-native'
import Constants from 'expo-constants'

import i18n from '../i18n'

const revenueCatConfig = Constants.expoConfig?.extra?.revenueCat as
  | {
      keys?: { ios?: string; android?: string; web?: string }
      isTestStore?: boolean
    }
  | undefined
const revenueCatPlatformKey =
  revenueCatConfig?.keys?.[Platform.OS as keyof typeof revenueCatConfig.keys] ??
  ''
const inferredRevenueCatTestStore =
  revenueCatPlatformKey.startsWith('test_') ||
  revenueCatPlatformKey.startsWith('rcb_sb_')

export const isRevenueCatTestStore =
  revenueCatConfig?.isTestStore ?? inferredRevenueCatTestStore

export function getNormalizedI18nLanguage(): 'en' | 'sv' {
  const language = i18n.resolvedLanguage ?? i18n.language ?? 'en'
  return language.toLowerCase().split('-')[0] === 'sv' ? 'sv' : 'en'
}
